import {fetchMyUser} from '@/scripts/auth-utils'
import {store} from '@/scripts/globals'

export default {
    data: function () {
        return {
            store,
        }
    },
    async created() {
        try {
            await fetchMyUser(true, true)
        } catch (e) {
            if (!e.message.includes('Not authenticated notice'))
                throw e
        }
    }
}